import { Progress } from "@/components/ui";
import { Media } from "@/services/bedrock";
import { ProjectFileUploader } from "@/utils/projectFileUploader";
import * as React from "react";
import { useEffect, useState } from "react";

interface Props {
  show: boolean;
  onUploading: (uploading: boolean) => void;
  onUploaded: (media: Media) => void;
}
const VideoPageUploader: React.FC<Props> = ({ show, onUploading, onUploaded }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const hiddenFileInput = React.useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (show) hiddenFileInput.current?.click();
  }, [show]);

  const handleFilesSelected = async (e: React.ChangeEvent<HTMLInputElement>): Promise<any> => {
    if (!e.target.files || e.target.files.length === 0) return;
    const inputFiles = e.target.files;

    setUploading(true);
    onUploading(true);
    setUploadProgress(0);
    const file = inputFiles[0];
    const timestamp = new Date().getTime();
    const fileName = file.name.split(".")[0] + timestamp;
    const mediaCategory = "VIDEO";
    const media = {
      id: -1,
      sortOrder: 0,
      category: mediaCategory,
      uri: URL.createObjectURL(file),
      type: file.type,
      extension: file.type.split("/")[1],
      imageFile: file,
      fileName,
    } as Media;

    const uploader = new ProjectFileUploader("videoPage");
    const uploaded = await uploader.prepareMedia([media], (_, progress) => {
      setUploadProgress(Math.trunc(progress * 100));
    });
    setUploading(false);
    onUploading(false);
    if (uploaded.length > 0) {
      onUploaded(uploaded[0]);
    }
  };

  return (
    <>
      {uploading && (
        <div className="flex items-center gap-4 min-w-100">
          <Progress value={uploadProgress} className="w-full">
            <Progress.Label>Uploading your video...</Progress.Label>
          </Progress>
        </div>
      )}
      <input
        type="file"
        accept="video/*"
        onChange={handleFilesSelected}
        ref={hiddenFileInput}
        style={{ display: "none" }}
      />
    </>
  );
};

export default VideoPageUploader;
